import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

import config from '../../config/enviroment';
import './styles.scss';

export default function ForgotPassword() {
    const [backgroundRandom, setBackgroundRandom] = useState(
        Math.floor(Math.random() * 4 + 1),
    );
    const [loading, setLoading] = useState(false);
    const [apiBadRequestNotif, setApiBadRequestNotif] = useState(false);
    const [apiGoodRequestNotif, setApiGoodRequestNotif] = useState(false);
    const [secondsRedirect, setSecondsRedirect] = useState(false);
    const [validation, setValidation] = useState(false);
    const [email, setEmail] = useState('');

    const history = useHistory();

    function axiosRequest() {
        setLoading(true);

        axios
            .post(`${config.authURL}forgotpassword`, { email })
            .then(_ => {
                setLoading(false);
                setEmail('');
                setApiGoodRequestNotif(true);
                setSecondsRedirect(15);
            })
            .catch(err => {
                setLoading(false);
                setApiBadRequestNotif(err?.response?.data?.message);
            });
    }

    function emailValidation() {
        const regexp =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (email === '' || !regexp.test(email)) return false;

        return true;
    }

    function onSubmit(e) {
        e.preventDefault();
        setValidation(true);

        if (emailValidation()) {
            axiosRequest();
            setValidation(false);
        }
    }

    useEffect(() => {
        if (secondsRedirect > 0)
            setTimeout(() => setSecondsRedirect(secondsRedirect - 1), 1000);

        if (secondsRedirect === 0) history.push('/');
    }, [secondsRedirect]);

    return (
        <div className="forgotPassword-body">
            <div
                className="imagesWrapper"
                key={`imagesWrapper-${backgroundRandom}`}>
                <img
                    className="bg-img"
                    src={require(`../../assets/images/background${backgroundRandom}.png`)}
                    alt="background-img"
                />
                <img
                    className="bg-effect"
                    src={require(`../../assets/images/top-right-background-effect.png`)}
                    alt="background-effect"
                />
            </div>
            <div className="loginFormWrapper">
                <img
                    className="form-header-range"
                    src={require('../../assets/images/form-header-range.svg')}
                    alt="form-header-range"
                />
                <div className="loginFormContent">
                    <div className="logo">
                        <img
                            className="logo-neo"
                            src={require('../../assets/images/logo-neo.svg')}
                            alt="Neo"
                        />
                        <img
                            className="text-neo"
                            src={require('../../assets/images/text-neo.svg')}
                            alt="Neo"
                        />
                    </div>
                    <div className="title">
                        <h4>Forgot your password?</h4>
                        <p>Enter your email</p>
                    </div>
                    {apiBadRequestNotif && (
                        <Alert
                            variant="danger"
                            onClose={() => setApiBadRequestNotif(false)}
                            dismissible>
                            <p>{apiBadRequestNotif}</p>
                        </Alert>
                    )}
                    {!apiGoodRequestNotif ? (
                        <>
                            <Form
                                className="inputs-form"
                                onKeyPress={e =>
                                    e.key === 'Enter' && onSubmit(e)
                                }>
                                <Form.Group className="input-email">
                                    <Form.Control
                                        required
                                        size="lg"
                                        type="email"
                                        placeholder="Email"
                                        name="email"
                                        value={email}
                                        onChange={e => {
                                            setEmail(e.target.value);
                                            setApiBadRequestNotif(false);
                                        }}
                                        isInvalid={
                                            validation &&
                                            (!emailValidation() || email === '')
                                                ? true
                                                : false
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a email.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form>
                            <Button
                                className="submit-form"
                                variant={
                                    email !== '' ? 'neoPrimary' : 'neoSecondary'
                                }
                                disabled={loading ? true : false}
                                onClick={e => onSubmit(e)}>
                                {loading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    'Submit'
                                )}
                            </Button>
                            <Link to="/" className="forgot-password">
                                Return to log in
                            </Link>
                        </>
                    ) : (
                        <>
                            <Alert
                                variant="success"
                                onClose={() => setApiGoodRequestNotif(false)}
                                className="forgotPassword__notif-success">
                                An email with instructions to reset your
                                password has been sent to the address you have
                                provided.
                            </Alert>
                            <p className="forgotPassword__message-success">
                                You'll be redirected to the log in page in{' '}
                                {secondsRedirect} seconds.
                                <br />
                                Or click&nbsp;
                                <Link to="/">here</Link>
                                &nbsp;to redirect now.
                            </p>
                        </>
                    )}
                </div>
                <div className="poweredBy">
                    <a className="by-antares" href="#">
                        powered by
                    </a>
                    <br></br>
                    <img
                        className="logo-antares"
                        src={require('../../assets/images/logo-antares.svg')}
                        alt="Antares vision group"
                    />
                </div>
            </div>
        </div>
    );
}
